import './accesibiltyButton.scss';
import GlobalContext from '@/contexts/globalContext';
import useMobile from '@/hooks/useMobile';
import accImage from '../../../assets/images/accesibilidad.svg';
const AccesibiltyButton = (props: any) => {
    const mobile = useMobile();
    const changeFontSize = (action: string, fontSize: any) => {
        if (typeof window !== 'undefined') {
            const item = document.querySelector('html') || {
                style: { fontSize },
            };
            switch (action) {
                case '+':
                    if (fontSize?.get < 120) {
                        item.style.fontSize = `${fontSize.get + 20}%`;
                        fontSize.set(fontSize.get + 20);
                    }
                    break;
                case '-':
                    if (fontSize?.get > 80) {
                        item.style.fontSize = `${fontSize.get - 20}%`;
                        fontSize.set(fontSize.get - 20);
                    }
                    break;
            }
        }
    };
    return (
        <GlobalContext.Consumer>
            {(data) => (
                <div
                    className={`a-accesibiltyButton${
                        mobile ? '--disable' : ''
                    }`}
                >
                    <div className="a-accesibiltyButton__container">
                        <img src={accImage} alt="acc" />
                        <div className="a-accesibiltyButton__container__accessibility">
                            <div
                                role="button"
                                className="a-accesibiltyButton__container__accessibility__item"
                            >
                                <i
                                    className={`icon m-header__icon ${
                                        props.isDark ? 'icon-sun' : 'icon-moon'
                                    }`}
                                    onClick={props.actionTheme}
                                />
                            </div>
                            <div
                                className={`a-accesibiltyButton__container__accessibility__item ${
                                    data.fontSize?.get === 80 ? '-disable' : ''
                                }`}
                                onClick={() =>
                                    changeFontSize('-', data.fontSize)
                                }
                            >
                                <p>A-</p>
                            </div>
                            <div
                                className={`a-accesibiltyButton__container__accessibility__item ${
                                    data.fontSize?.get === 120 ? '-disable' : ''
                                }`}
                                onClick={() =>
                                    changeFontSize('+', data.fontSize)
                                }
                            >
                                <p>A+</p>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </GlobalContext.Consumer>
    );
};

export default AccesibiltyButton;
